import { TPlaylistContentItem } from '../types/responses/video';

export const isVideoPlaylistItem = (item: TPlaylistContentItem) =>
  item.type === 'video' ||
  item.kind === 'video' ||
  item.contentType === 'video';
